const text = value => String(value ?? '').trim()
const projected = /\+\s*\d+\s*(?:wks?|weeks?)\b|project(?:ed|ion)|estimate|to confirm|to ingest|confirm from|prior[- ]season|last year/i
const isoDay = value => {
  const s = text(value).slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null
  const day = new Date(`${s}T00:00:00Z`)
  return Number.isFinite(+day) && day.toISOString().slice(0, 10) === s ? s : null
}

// A source citation is a research input. Only comparison with an independently
// checked official season manifest can promote it to a verified date.
export function bodyDateEvidence(row) {
  const date = isoDay(row.sr_event_date), status = text(row.sr_date_status), source = text(row.sr_date_source)
  if (/conflict/i.test(status) || (/confirmed|dated/i.test(status) && projected.test(source))) return 'conflict'
  if (projected.test(status) || projected.test(source)) return 'projected'
  if (!date) return 'unknown'
  const year = Number(text(row.sr_season_year)), month = Number(date.slice(5, 7))
  if (year && Number(date.slice(0, 4)) - (month < 7 ? 1 : 0) !== year) return 'conflict'
  if (/https?:\/\//i.test(source)) return 'source-cited'
  return 'needs-source'
}

export function bodyRecordReadiness(item) {
  const row = item.raw || item
  const inactive = row.sr_scope_status === 'Out of Scope' || /^RETIRED\s*-/i.test(text(row.championship_name || item.name))
  const owner = text(row.sr_assigned_rep || item.rep)
  return { inactive, owner: /^(?:unassigned|unknown|none|null|undefined|n\/?a|-)$/i.test(owner) ? '' : owner,
    date: inactive ? null : bodyDateEvidence(row) }
}
